export enum TipoUsuario {
    ADMINISTRADOR = 'Administrador',
    MASTER = 'Master',
    COORDENADOR = 'Coordenador',
    //AUDITAGEM = 'Auditagem',
    INVENTARIANTE = 'Inventariante'
}